export default {
  attendances: [],
  auth: null,
  fases: [],
  helps: [],
  places: [],
}